export default {
  init: function(ele) {
    console.log('StudentCoursePortal initialization function called');
    Kadenze.WebApp.initializePjax();
  }
};

